// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyAWvSe4voW0AslmweqBHPdJEO7PKOQtzbY",
  authDomain: "carhero-fd721.firebaseapp.com",
  projectId: "carhero-fd721",
  storageBucket: "carhero-fd721.firebasestorage.app",
  messagingSenderId: "573250115333",
  appId: "1:573250115333:web:26bf1b9098510a75ed896c",
  measurementId: "G-VB9YPFPJ5B"
};

// Initialize Firebase
const firebase_app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export {firebase_app};